import React, { useState, useRef, useEffect } from 'react'
import {
  Card,
  DatePicker,
  Form,
  Modal,
  Select,
  Row,
  Col,
  Button,
  Input,
  Radio,
} from 'antd'
import { FilterFilled } from '@ant-design/icons'
import '../../css/case.scss'
import _ from 'lodash'
import ApolloClientService from '../../services/apolloclient.service'
import { constants } from '../../constants'
import util from '../../util/util'
import {
  fechactioncase,
  fetchHealthCoachList,
} from '../../store/action/actioncases.action'
import { getCustomersIdAndNameList } from '../../store/action/customer.action'
import { connect } from 'react-redux'
import FilterList from './actioncase.filterlist'
import { messageFilter } from '../../store/action/actioncases.action'
import { messageScope, stripMessageScope } from '../../util/messagefilter'
import { useHistory } from 'react-router-dom'
const { RangePicker } = DatePicker
const apolloClient = new ApolloClientService()

const titles = [
  { label: 'New Patient', value: constants.ACTION_CASE_TITLE.NEW_PATIENT },
  {
    label: 'New Device Order',
    value: constants.ACTION_CASE_TITLE.NEW_DEVICE_ORDER,
  },
  {
    label: 'Patient Technical',
    value: constants.ACTION_CASE_TITLE.PATIENT_TECHNICAL,
  },
  {
    label: 'System Technical',
    value: constants.ACTION_CASE_TITLE.SYSTEM_TECHNICAL,
  },
  {
    label: 'External Patient',
    value: constants.ACTION_CASE_TITLE.EXTERNAL_PATIENT,
  },
  {
    label: 'Delete Account Request',
    value: constants.ACTION_CASE_TITLE.DELETE_ACCOUNT_REQUEST,
  },
  {
    label: 'MoveAI Message',
    value: constants.ACTION_CASE_TITLE.MOVEAI_MESSAGE,
  },
]

const status = [
  { label: 'Assigned ', value: constants.ACTION_CASE_STATUS.ASSIGNED },
  { label: 'Unassigned', value: constants.ACTION_CASE_STATUS.UNASSIGNED },
  { label: 'Resolved', value: constants.ACTION_CASE_STATUS.RESOLVED },
  { label: 'Unresolved', value: constants.ACTION_CASE_STATUS.UNRESOLVED },
  { label: 'Not an Issue', value: constants.ACTION_CASE_STATUS.NOTANISSUE },
]

const priorities = [
  { label: 'P1 ', value: constants.ACTION_CASE_PRIORITY.ONE },
  { label: 'P2', value: constants.ACTION_CASE_PRIORITY.TWO },
  { label: 'P3', value: constants.ACTION_CASE_PRIORITY.THREE },
  { label: 'P4', value: constants.ACTION_CASE_PRIORITY.FOUR },
  { label: 'Blocker', value: constants.ACTION_CASE_PRIORITY.BLOCKER },
  { label: 'Critical', value: constants.ACTION_CASE_PRIORITY.CRITICAL },
]

function CaseFilter(props) {
  var history = useHistory()

  const isadmin =
    props.currentUserRole == constants.ROLE.ADMIN ||
    props.currentUserRole == constants.ROLE.SURGEON ||
    props.currentUserRole == constants.ROLE.MEDICAL_ASSOCIATE ||
    props.currentUserRole == constants.ROLE.COMPANY_ADMIN ||
    props.currentUserRole == constants.ROLE.COMPANY_HEALTHCOACH ||
    false
  const currentUserRole = props.currentUserRole

  const formRef = useRef(null)
  const [open, setOpen] = useState(false)
  const [caseNumber, setCaseNumber] = useState('')
  const [patientName, setPatientName] = useState('')
  const [last4DigitsOfPhone, setLast4DigitsOfPhone] = useState('')
  const [healthCoachList, setHealthCoachList] = useState([])
  const [customerList, setCustomerList] = useState([])
  const [isLoading, setIsLoading] = useState({
    healthCoachList: false,
    customerList: false,
  })

  useEffect(() => {
    if (currentUserRole != constants.ROLE.COMPANY_HEALTHCOACH) {
      !isadmin && props.getHealthCoachList({ companyid: props.companyId })
    }

    !isadmin &&
      props.getCustomersIdAndNameList({
        companyId: props.companyId,
        healthCoachId: '',
      })
  }, [])

  useEffect(() => {
    console.log('HCL', props.healthCoachList)
    const userList = props.healthCoachList?.map((user) => ({
      value: user._id,
      label: user.firstname + ' ' + user.lastname,
    }))
    setHealthCoachList(userList)
  }, [props.healthCoachList])

  useEffect(() => {
    console.log('ASD', props.customer)
    const userList = props.customer.customers?.map((customer) => ({
      value: customer.id,
      label: customer.name,
    }))
    setCustomerList(userList)
  }, [props.customer])

  async function fetchCustomerList(companyId, healthCoachId) {
    try {
      setIsLoading((prev) => ({ ...prev, customerList: true }))

      console.log('fetchCustomerList ------')
      const customerList = await apolloClient.getCustomersIdAndNameList({
        companyId: companyId,
        healthCoachId: healthCoachId ?? '',
      })

      console.log('customerList -------->>', customerList)
      if (customerList.status == 'SUCCESS') {
        const userList = customerList?.customers?.map((customer) => ({
          value: customer.id,
          label: customer.name,
        }))
        setCustomerList(userList)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading((prev) => ({ ...prev, customerList: false }))
    }
  }

  const onFinish = () => {
    formRef.current
      .validateFields()
      .then((values) => {
        if (!_.isEmpty(values.updatedAtRange)) {
          const utcStartDate = values.updatedAtRange[0].utc().format()
          const utcEndDate = values.updatedAtRange[1].utc().format()
          const utcDatesArray = [utcStartDate, utcEndDate]
          values.updatedAtRange = utcDatesArray
        }
        let filterData = {
          ...values,
          caseNumbers:
            // values.caseNumbers?.trim()?.length > 0 ? caseNumber : null,
            typeof values.caseNumbers === "string" && values.caseNumbers.trim().length > 0
            ? caseNumber
            : null
        }
        // if(props.customer?.customers && !isadmin){
        //   const cid=props.customer.customers.map(customer=>customer.id);
        //   filterData.customerIds=cid;
        // }
        console.log('filterData ------->', filterData)

        if (props.isMessages) {
          // Messages tab: always scope to the open customer (and Surgeon
          // Messages only — enforced by messageScope). Persist the other user
          // filters (name, phone, dates) to msgfilter.
          props.messageFilter(filterData)

          const queryFilters = {
            ...filterData,
            ...messageScope({
              customer: props.customerData,
              decoded: props.decoded,
            }),
          }
          if (props.groupby && props.selectedIndex) {
            queryFilters.surgeonId = props.selectedIndex
          }
          if (
            props.user?.role == constants.ROLE.SURGEON ||
            props.user?.surgeon
          ) {
            queryFilters.surgeonId = props.user?.surgeon
          }
          props.fetchActionCase(
            {
              metadata: { current: 1, pageSize: 20 },
              filters: queryFilters,
              sorter: { field: 'lastUpdated', order: 'descend' },
            },
            undefined,
            true,
            false
          )
          setOpen(false)
          return
        }

        props.messageFilter(filterData)

        if (!isadmin) {
          if (history.location?.state?.customerid) {
            const { customerid } = history.location?.state
            filterData.customerIds = [customerid]
          }
          props.fetchActionCase(
            {
              metadata: { current: 1, pageSize: 20 },
              // msgfilter is shared with Clinic > Messages — strip its
              // Surgeon-Message scope so it can't leak into the Cases query.
              filters: stripMessageScope({ ...props.msgfilter, ...filterData }),
              sorter: { field: 'lastUpdated', order: 'descend' },
            },
            undefined,
            true,
            false
          )
        } else {
          if (props.groupby && props.selectedIndex) {
            filterData = { ...filterData, surgeonId: props.selectedIndex }
          }
          if (
            props.user?.role == constants.ROLE.SURGEON ||
            props.user?.surgeon
          ) {
            filterData.surgeonId = props.user?.surgeon
          }
          filterData.customerIds = [props.customerData?._id]

          props.fetchActionCase(
            {
              metadata: { current: 1, pageSize: 20 },
              filters: filterData,
              sorter: { field: 'lastUpdated', order: 'descend' },
            },
            undefined,
            true,
            false
          )
        }
        setOpen(false)
      })
      .catch((errorInfo) => {
        console.log('Validate Failed:', errorInfo)
      })
  }

  var handleModalOpen = () => {
    setOpen(true)
  }

  const handleClearFilter = () => {
    let filters = {}
    if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
      filters.surgeonId = props.user?.surgeon
    }

    if (props.isMessages) {
      // Clearing on the Messages tab clears the user filters but always
      // re-applies the customer scope, so the admin stays scoped to this
      // customer (and to Surgeon Messages, enforced by messageScope).
      props.messageFilter({})
      const queryFilters = {
        ...messageScope({
          customer: props.customerData,
          decoded: props.decoded,
        }),
      }
      if (props.groupby && props.selectedIndex) {
        queryFilters.surgeonId = props.selectedIndex
      }
      if (props.user?.role == constants.ROLE.SURGEON || props.user?.surgeon) {
        queryFilters.surgeonId = props.user?.surgeon
      }
      props.fetchActionCase(
        {
          metadata: { current: 1, pageSize: 20 },
          filters: queryFilters,
          sorter: { field: 'lastUpdated', order: 'descend' },
        },
        undefined,
        true,
        false
      )
      if (formRef.current) formRef.current.resetFields()
      return
    }

    props.messageFilter({})
    // if(props.customer?.customers && !isadmin){
    //   const cid=props.customer.customers.map(customer=>customer.id);
    //   filters.customerIds=cid;
    // }
    //  else{
    //   filters.customerIds=[props.customerData?._id]
    //  }
    if (!isadmin) {
      props.fetchActionCase(
        {
          metadata: { current: 1, pageSize: 20 },
          filters: { ...filters },
          sorter: { field: 'lastUpdated', order: 'descend' },
        },
        undefined,
        true,
        false
      )
    } else {
      if (props.groupby && props.selectedIndex) {
        filters = { ...filters, surgeonId: props.selectedIndex }
      }
      filters.customerIds = [props?.decoded?.customer]
      props.fetchActionCase(
        {
          metadata: { current: 1, pageSize: 20 },
          filters: filters,
          sorter: { field: 'lastUpdated', order: 'descend' },
        },
        undefined,
        true,
        false
      )
    }

    if (!formRef.current) return
    formRef.current.resetFields()
  }

  var renderCard = () => {
    return (
      <Card bordered={false}>
        <Form
          initialValues={props.filter ? props.filter : null}
          ref={formRef}
          name='case'
          labelCol={{ span: 8 }}
        >
          {!isadmin && (
            <Form.Item
              name='customerIds'
              label='Clinic Name'
              //  rules={[{ required: true, message: 'Please select at least one customer name.' }]}
            >
              <Select
                mode='multiple'
                placeholder='Select clinic name'
                loading={isLoading.customerList}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {customerList.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {isadmin && (
            <Form.Item
              name='patientName'
              label='Last Name'
              //  rules={[{ required: true, message: 'Please select at least one case number.' }]}
            >
              <Input
                value={patientName}
                onChange={(e) => setPatientName(e.target.value)}
                placeholder='Enter Last Name'
              />
            </Form.Item>
          )}
          {!isadmin && (
            <Form.Item
              name='caseNumbers'
              label='Case Number '
              //  rules={[{ required: true, message: 'Please select at least one case number.' }]}
            >
              <Input
                value={caseNumber}
                onChange={(e) =>
                  setCaseNumber([...new Set(e.target.value.split(','))])
                }
                placeholder='Enter case number'
              />
            </Form.Item>
          )}

          <Form.Item
            name='last4DigitsOfPhone'
            label='Last 4 Digits of phone '
            //  rules={[{ required: true, message: 'Please select at least one case number.' }]}
          >
            <Input
              value={last4DigitsOfPhone}
              onChange={(e) => setLast4DigitsOfPhone(e.target.value)}
              placeholder='Enter Last 4 Digits of phone'
            />
          </Form.Item>

          {!props.isMessages && (
            <Form.Item
              name='titles'
              label='Type '
              //  rules={[{ required: true, message: 'Please select at least one title.' }]}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                mode='multiple'
                placeholder='Select Type'
              >
                {titles.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          <Form.Item
            name='status'
            label='Status'
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            // rules={[{ required: true, message: 'Please select at least one status.' }]}
          >
            <Select
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              mode='multiple'
              placeholder='Select Status'
            >
              {status.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          {!isadmin && (
            <Form.Item
              name='priorities'
              label='Priority'
              //  rules={[{ required: true, message: 'Please select at least one priority.' }]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                mode='multiple'
                placeholder='Select Priority'
              >
                {priorities.map((option) => (
                  <Select.Option key={option.value} value={option.value}>
                    {option.label}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {currentUserRole != constants.ROLE.COMPANY_HEALTHCOACH &&
            !isadmin && (
              <Form.Item
                name='healthCoachIds'
                label='Assigned To'
                // rules={[{ required: true, message: 'Please select at least one health coach.' }]}
              >
                <Select
                  mode='multiple'
                  placeholder='Select assignee'
                  loading={isLoading.healthCoachList}
                  showSearch
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {healthCoachList
                    ?.sort((a, b) => a?.label?.localeCompare(b.label))
                    ?.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        {option.label}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            )}

          <Form.Item
            name='updatedAtRange'
            label='Updated Date'
            // rules={[{ required: true, message: 'Please select date' }]}
          >
            <RangePicker />
          </Form.Item>

          {isadmin && (
                     <Form.Item name='type' label='Patient Type'>
                     <Radio.Group buttonStyle='solid' defaultValue='active'>
                          <Radio.Button value='active'>Active</Radio.Button>
                          <Radio.Button value='inactive'>Inactive</Radio.Button>
                      </Radio.Group>
                    </Form.Item>
          )}
        </Form>
      </Card>
    )
  }
  return (
    <>
      <Row className='filterRow' align={'end'}>
        <Col flex={'auto'}>
          <FilterList />
        </Col>
        <Col flex={'30%'}>
          <Row justify={'end'}>
            <Button
              className={'clearBtn'}
              type='primary'
              onClick={() => {
                handleClearFilter()
              }}
              // disabled={props.filters && Object.keys(props.filters).length <= 1}
            >
              Clear Filter
            </Button>
            <FilterFilled
              id={'messagefilter'}
              className={'filterIcon'}
              onClick={handleModalOpen}
            />
          </Row>
        </Col>

        <Modal
          className={'filterModal'}
          visible={open}
          closable={false}
          maskClosable={false}
          width={'40%'}
          okText={'Filter'}
          onOk={onFinish}
          onCancel={() => setOpen(false)}
        >
          {renderCard()}
        </Modal>
      </Row>
    </>
  )
}

const mapStateToProps = (state) => {
  console.log('state ---------------->>>', state)

  return {
    currentUserRole: state.profile?.user?.role,
    decoded: util.verifyToken(state.profile.token, true),
    companyId: state.profile?.company?._id,
    editCase: state.actioncase.editcase,
    isLoading: state.actioncase.isLoading,
    customer: state.customer,
    customerData: state.profile.customer,
    healthCoachList: state.actioncase.healthCoachList,
    token: util.verifyToken(state.profile.token),
    user: state.profile.user,
    filter: state.actioncase.filters,
    selectedIndex: state.message.selectedIndex,
    groupby: state.message.groupby,
    msgfilter: state.message.filter,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getHealthCoachList: (params) => {
      return dispatch(fetchHealthCoachList(params))
    },
    fetchActionCase: (params, select, ischeck, isNewMsg) => {
      return dispatch(fechactioncase(params, select, ischeck, isNewMsg))
    },
    messageFilter: (data) => dispatch(messageFilter(data)),
    getCustomersIdAndNameList: (params) => {
      dispatch(getCustomersIdAndNameList(params))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CaseFilter)
